module.exports = __webpack_public_path__ + "static/mobile-food-body-1-8938ff3c9ee944b229df4b7e51d3e81b.jpg";